import { safeGet } from '../../utils/safeGet'
import { get as _get } from '../../utils/fetcher'

export default {
  state: {
    permissions: {},
  },
  mutations: {
    setUserPermissions(state, data) {
      state.permissions = data
    },
  },
  actions: {
    setUserPermissions({ commit }, data) {
      commit('setUserPermissions', data)
    },
  },

  getters: {
    getPermissions: (state) => state.permissions,

    // Permissions of the given asset class (defaults to the selected one), or {} if none are defined.
    getAssetClassPermissions: (state, getters, rootState, rootGetters) => (assetClass) => {
      const slug = assetClass || rootGetters.getSelectedAssetClass
      const list = safeGet(() => state.permissions.assetClassPermissions, null)
      return (Array.isArray(list) && list.find((p) => p.assetClass === slug)) || {}
    },

    // Resolves a permission flag: the asset-class entry wins when it defines the key,
    // otherwise falls back to the global userPermissions. Unknown keys are false.
    can: (state, getters) => (permission, assetClass) => {
      const scoped = getters.getAssetClassPermissions(assetClass)
      if (Object.prototype.hasOwnProperty.call(scoped, permission)) return scoped[permission] === true
      return safeGet(() => state.permissions.userPermissions[permission], false) === true
    },

    can_ViewTypeCategory: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewTypeCategory, false)
    },
    can_ViewAdditionalFeatures: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewAdditionalFeatures, false)
    },
    can_ViewAdditionalInfo: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewAdditionalInfo, false)
    },
    can_ViewTargetMarket: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewTargetMarket, false)
    },
    can_ViewTestProducts: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewTestProducts, false)
    },
    can_ExportAllRevisions: (state) => {
      return safeGet(() => state.permissions.userPermissions.canExportAllRevisions, false)
    },
    can_ViewScoringProfiles: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewScoringProfiles, false)
    },
    can_ViewScoringProfileModels: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewScoringProfileModels, false)
    },
    can_ViewScoringMonitoring: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewScoringMonitoring, false)
    },
    can_ChangePassword: (state) => {
      return safeGet(() => state.permissions.userPermissions.canChangePassword, false)
    },
    can_ViewSustainabilityInfo: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewSustainabilityInfo, false)
    },
    can_ViewBuildInformation: (state) => {
      return safeGet(() => state.permissions.userPermissions.canViewBuildInformation, false)
    },
    getAdditionalInfoStartDate: (state) => {
      return safeGet(() => state.permissions.additionalInfoStartDate, null)
    },
  },
}
